import React from 'react';
import {__, _nonce, _solea_user_is_admin, solea_print_list} from '../../../../assets/javascripts/library.js';
import ReactDOM from "react-dom/client";
import {SelectedAddons} from "../../../../assets/javascripts/registration-validator.js";
import MailComposer from "../../mailclient/mail-composer.jsx";
import {ToasterProvider, useToaster} from "../../global-components/toaster.jsx";
import Overview from "../partials/overview.jsx";
import Settings from "../partials/settings.jsx";

function EventOverviewActions({event}) {
    const { showToast } = useToaster();

    const do_archive = () => {
        if (!_solea_user_is_admin()) {
            return
        }

        const response = fetch("/wp-json/solea/event-details/print-page/edit-settings/archive-event", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                event_id: event.id,
                solea_nonce: _nonce(),


            }),
        })
            .then((res) => res.json())
            .then((data) => {
                document.getElementById('solea-action-buttons').style.display = 'none';
                document.getElementById('solea-navigation-bar').style.display = 'none';
                document.getElementById('solea_event_overview_contents').innerHTML = __('This event is archived.', 'solea');
                showToast( __('The event was archived successfully.', 'solea') )
                }
            );

    }

    const show_settings = ()  => {
        if (!_solea_user_is_admin()) {
            return
        }

        const response = fetch("/wp-json/solea/event-details/print-page/settings", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                event_id: event.id,
                tab: 'overview',
                solea_nonce: _nonce(),


            }),
        })
            .then((res) => res.json())
            .then((data) => {
                    var container = document.getElementById('area_overview');
                    var root = ReactDOM.createRoot(container);
                    root.render(
                        <ToasterProvider>
                            <div id="solea_event_group_contents">
                                <Settings link='overview' result={data.result} />
                            </div>
                        </ToasterProvider>
                    );
                }
            );
    }

    const payment_reminder = () => {
        const response = fetch("/wp-json/solea/event-details/action/payment-reminder", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                event_id: event.id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                try {
                    const container = document.getElementById('solea_event_overview_contents');
                    const root = ReactDOM.createRoot(container);

                    root.render(
                        <ToasterProvider>
                            <div id="solea_event_group_contents">
                                <Overview link="overview" result={data.result} toast_message={data.mails_sent} />
                            </div>
                        </ToasterProvider>
                    );
                } catch {
                    window.location.reload();
                }

            });
    }

    const last_payment_reminder = () => {
        const response = fetch("/wp-json/solea/event-details/action/last-payment-reminder", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                event_id: event.id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                try {
                    const container = document.getElementById('solea_event_overview_contents');
                    const root = ReactDOM.createRoot(container);

                    root.render(
                        <ToasterProvider>
                            <div id="solea_event_group_contents">
                                <Overview link="overview" result={data.result} toast_message={data.mails_sent} />
                            </div>
                        </ToasterProvider>
                    );
                } catch {
                    window.location.reload();
                }

            });
    }

    const mailclient = () => {
        const response = fetch("/wp-json/solea/mail-client/open-composer", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                mode: 'group',
                group_name: 'participation_all',
                event_id: event.id,
                solea_nonce: _nonce(),
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                try {
                    const container = document.getElementById('solea_event_overview_contents');
                    const root = ReactDOM.createRoot(container);

                    root.render(
                        <ToasterProvider>
                            <MailComposer event_id={event.id} recipients={data.recipients} comes_from="overview" />
                        </ToasterProvider>
                    );
                } catch {
                    window.location.reload();
                }

            });
    }


    return (
        <div><br />
            <label onClick={() => {
                solea_print_list('participantlist', event.id);
            }}
               className="button solea-button solea-event-action-button">{ __( 'Participant list', 'solea' ) }
                (PDF)</label>

            <label  onClick={() => {
                solea_print_list('participant-csvlist', event.id);
            }}
               className="button solea-button solea-event-action-button">{ __( 'Participant list', 'solea' ) }
                (CSV)</label>

            <label
                onClick={() => {
                    solea_print_list('participant-csvlist-ksv', event.id);
                }}
               className="button solea-button solea-event-action-button">{ __( 'Funding list - KSV', 'solea' ) }
                (CSV))</label>

            <label
                onClick={() => {
                    solea_print_list('kitchenoverview', event.id);
                }}
               className="button solea-button solea-event-action-button">{ __( 'Kitchen overview', 'solea' ) }
                (PDF)</label>

            <label
                onClick={() => {
                    solea_print_list('kitchenallergies', event.id);
                }}
               className="button solea-button solea-event-action-button">{ __( 'Kitchen list with allergies', 'solea' ) }
                (PDF)</label>

            <label
                onClick={() => {
                    solea_print_list('firstaid', event.id);
                }}
               className="button solea-button solea-event-action-button">{ __( 'First aid list', 'solea' ) }
                (PDF)</label>

            <label
                onClick={() => {
                    solea_print_list('amountlist', event.id);
                }}
               className="button solea-button solea-event-action-button">{ __( 'Amount list', 'solea' ) }
                (PDF)</label>

            <label
                onClick={() => {
                    solea_print_list('alcoholiclist', event.id);
                }}
               className="button solea-button solea-event-action-button">{ __( 'Drinking list (alcoholic)', 'solea' ) }
                (PDF)</label>

            <label
                onClick={() => {
                    solea_print_list('non-alcoholiclist', event.id);
                }}
               className="button solea-button solea-event-action-button">{ __( 'Drinking list (non-alcoholic)', 'solea' ) }
                (PDF)</label>

            <label
                onClick={() => {
                    solea_print_list('photopermission', event.id);
                }}
               className="button solea-button solea-event-action-button">{ __( 'Photo permission', 'solea' ) }
                (PDF)</label>

            <label
                onClick={payment_reminder}
               className="button solea-button solea-event-action-button warning">{ __( 'Send payment reminders', 'solea' ) }</label>

            <label
                onClick={last_payment_reminder}
                className="button solea-button solea-event-action-button cancel">{ __( 'Send last payment reminders (5 days)', 'solea' ) }</label>

            <label
                onClick={mailclient}
               className="button solea-button solea-event-action-button">{ __( 'Send e-mail to all participants', 'solea' ) }</label>

            { _solea_user_is_admin() &&(
                <label
                    onClick={show_settings}
                    className="button solea-button solea-event-action-button">{ __( 'Change event settings', 'solea' ) }
                </label>
                ) }
            { _solea_user_is_admin() && !event.signup_allowed && (
                <label
                    onClick={do_archive}
                    className="button solea-button solea-event-action-button cancel">{ __( 'Archive event', 'solea' ) }
                </label>
            )}

        </div>
    )
}

export default EventOverviewActions;